import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import BibCard from '../BibCard/BibCard';

import './BibSeries.scss';

export default class BibSeries extends React.PureComponent {
  renderItem(bib) {
    const { catalogBib } = this.props;

    const metadataId = bib.get('metadataId');
    const key = `${metadataId}-vol${bib.get('volume')}`;
    const isCurrentItem = catalogBib && metadataId === catalogBib.get('metadataId');

    return (
      <BibCard
        bib={bib}
        number={bib.get('volume')}
        key={key}
        isCurrentItem={isCurrentItem}
        source={this.props.source}
        handleBibTitle={this.props.handleBibTitle}
        handleBibImage={this.props.handleBibImage}
      />
    );
  }

  render() {
    const { bibs } = this.props;
    if (!bibs || !bibs.size) return null;
    return <div className="cp-bib-card-row">{bibs.map(bib => this.renderItem(bib))}</div>;
  }
}

BibSeries.propTypes = {
  bibs: ImmutablePropTypes.listOf(bibShape),
  catalogBib: catalogBibShape,
  source: PropTypes.string,
  handleBibTitle: PropTypes.func,
  handleBibImage: PropTypes.func
};
